import axios from 'axios'
import { APP_API_BASE } from '@/utils/api-base'

// 创建axios实例
const service = axios.create({
    baseURL: APP_API_BASE,
    timeout: 10000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
    config => {
        if (!(config.data instanceof FormData)) {
            config.headers['Content-Type'] = 'application/json'
        }
        try {
            const raw = window.localStorage.getItem('token')
            const token = raw != null ? String(raw).trim() : ''
            if (token && token !== 'null' && token !== 'undefined') {
                config.headers['Authorization'] = 'Bearer ' + token
            }
        } catch (e) {
            // ignore
        }
        return config
    },
    error => {
        // Do something with request error
        console.log(error) // for debug
        Promise.reject(error)
    }
)

// response 拦截器
service.interceptors.response.use(
    response => {
        return response.data
    },
    error => {
        return Promise.reject(error)
    }
)
export default service
